import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-back-navigator',
  templateUrl: './back-navigator.component.html',
  styleUrls: ['./back-navigator.component.scss'],
})
export class BackNavigatorComponent {
  @Input() title?: string;
  @Output() backClicked: EventEmitter<void> = new EventEmitter();

  constructor() {}

  onBackButtonClicked() {
    this.backClicked.emit();
  }
}
